// eslint-disable-next-line import/no-unresolved
import config from 'app-config';
import { get } from 'lodash';

export const getLobDefinition = (lineName) => {
    return get(config, `coverableAPIMapping.${lineName}`);
};

export const getCoverableDefinition = (lineName, coverableName) => {
    const coverables = get(config, `coverableAPIMapping.${lineName}.coverables`);
    const coverableKey = Object.keys(coverables)
        .find((key) => key.toLowerCase() === coverableName.toLowerCase());
    return coverables ? coverables[coverableKey] : undefined;
};

export default { getLobDefinition, getCoverableDefinition };
